module.exports = __webpack_public_path__ + "media/header-mobile-by.e1d2a546.mp4";